var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowSeperatorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "151px",
    height: "11px",
    viewBox: "0 0 151 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "EID/ITShop/Drawer/Suggested/Duration-Enter",
    transform: "translate(-303.000000, -72.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(72.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line-12",
    d: "M372.662848,24.5271708 L372.745131,24.5642122 L380.745131,29.0642122 L381.519864,29.5 L380.745131,29.9357878 L372.745131,34.4357878 C372.504452,34.5711697 372.199594,34.4858096 372.064212,34.2451306 C371.943873,34.0311938 371.997947,33.7665479 372.180485,33.6152959 L372.254869,33.5642122 L378.589,30 L232,30 C231.723858,30 231.5,29.7761424 231.5,29.5 C231.5,29.2545401 231.676875,29.0503916 231.910124,29.0080557 L232,29 L378.593,29 L372.254869,25.4357878 C372.040933,25.3154483 371.949717,25.0612021 372.027171,24.8371522 L372.064212,24.7548694 C372.184552,24.5409325 372.438798,24.4497168 372.662848,24.5271708 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSeperatorIcon);
export default __webpack_public_path__ + "static/media/arrow-seperator-icon.ff2e225aaf3dfc500e906461854c5ce8.svg";
export { ForwardRef as ReactComponent };